import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showUserManagementModal: false,
};

const admin = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setShowUserManagementModal: (state, action) => {
      state.showUserManagementModal = action.payload;
    },
  },
});

export const {
  setShowUserManagementModal,
} = admin.actions;

export default admin.reducer;
